import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Typography, Zoom } from '@mui/material';
import { HomePagePaths } from 'app/configs/routesConfig/homePage';
import { NoAvailableMessageContent } from 'app/shared/components/common/NoAvailableMessage';

import { selectIsSubCompanyCertificationPending } from 'store/auth/selectors';

import { CERTIFICATION_PENDING_MESSAGE, PERMISSION_MESSAGE } from './Forbidden403Page.constants';
import { Forbidden403PageTestIds } from './Forbidden403Page.testIds';

const Forbidden403Page = () => {
  const isCertificationPending = useSelector(selectIsSubCompanyCertificationPending);

  return (
    <div className="flex flex-col flex-1 items-center justify-center p-16">
      <div className="max-w-512 text-center">
        <Zoom in timeout={500}>
          <Typography className="mb-16" color="inherit" variant="medium48">
            403
          </Typography>
        </Zoom>
        <NoAvailableMessageContent
          message={isCertificationPending ? CERTIFICATION_PENDING_MESSAGE : PERMISSION_MESSAGE}
        />

        <Link
          className="font-medium"
          data-testid={Forbidden403PageTestIds.DASHBOARD_LINK}
          to={HomePagePaths.home.path}
        >
          Go back to dashboard
        </Link>
      </div>
    </div>
  );
};

export default Forbidden403Page;
